// extracted by mini-css-extract-plugin
module.exports = {"container":"slider_container__NsRHY","swipe":"slider_swipe__3gJ5z","swipe_wrap":"slider_swipe_wrap__2Rwp_","swipe_wrap_item":"slider_swipe_wrap_item__3izeQ"};